import { useTheme } from "../context/ThemeContext";

export default function Input({ label, value, onChange, placeholder, mono, style: s }) {
  const { mode } = useTheme();
  return (
    <div style={s}>
      {label && (
        <div style={{ fontSize:11, color:"var(--text-dim)", textTransform:"uppercase", letterSpacing:"0.07em", fontWeight:600, marginBottom:5 }}>
          {label}
        </div>
      )}
      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{ width:"100%", background:"var(--surface)", border:`1px solid var(--border)`, borderRadius:6, padding:"7px 10px", fontSize:12, color:"var(--text)", fontFamily: mono ? "'IBM Plex Mono', monospace" : "inherit", outline:"none" }}
      />
    </div>
  );
}
